var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-nav"},_vm._l((_vm.linkList),function(item){return _c('router-link',{key:item.label,staticClass:"app-nav__link",attrs:{"to":item.route},domProps:{"textContent":_vm._s(item.label)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }